import interstellarApi from './interstellarApi';

export interface TimeSlot {
  id?: number;
  schedule_id?: number;
  day_of_week: 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';
  is_open: boolean;
  open_time: string | null;
  close_time: string | null;
}

export interface OfficeSchedule {
  id: number;
  account_id: number;
  name: string;
  time_slots: TimeSlot[];
  created_at?: string | null;
  modified_at?: string | null;
}

interface OfficeSchedulesListResponse {
  total_count: number;
  page: number;
  page_size: number;
  schedules: OfficeSchedule[];
}

export interface CreateOfficeSchedulePayload {
  name: string;
  time_slots: Array<{
    day_of_week: 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';
    is_open: boolean;
    open_time?: string | null;
    close_time?: string | null;
  }>;
}

interface CreateOfficeScheduleResponse {
  message: string;
  id: number;
}

/**
 * Lista horarios de oficina de la cuenta: `GET /incoming-call-config/schedule`
 */
export const fetchOfficeSchedules = async (
  accountId: number,
  pageSize = 200
): Promise<OfficeSchedule[]> => {
  const response = await interstellarApi.get<OfficeSchedulesListResponse>(
    '/incoming-call-config/schedule',
    {
      params: {
        account_id: accountId,
        page: 1,
        page_size: pageSize,
      },
    }
  );
  return response.data.schedules ?? [];
};

/**
 * Obtiene detalle de un horario: `GET /incoming-call-config/schedule/{scheduleId}`
 */
export const fetchOfficeSchedule = async (scheduleId: number): Promise<OfficeSchedule> => {
  const response = await interstellarApi.get<OfficeSchedule>(
    `/incoming-call-config/schedule/${scheduleId}`
  );
  return response.data;
};

/**
 * Crea un nuevo horario de oficina: `POST /incoming-call-config/schedule`
 */
export const createOfficeSchedule = async (
  accountId: number,
  payload: CreateOfficeSchedulePayload
): Promise<CreateOfficeScheduleResponse> => {
  const response = await interstellarApi.post<CreateOfficeScheduleResponse>(
    '/incoming-call-config/schedule',
    payload,
    { params: { account_id: accountId } }
  );
  return response.data;
};

/**
 * Actualiza un horario existente: `PUT /incoming-call-config/schedule/{scheduleId}`
 */
export const updateOfficeSchedule = async (
  scheduleId: number,
  payload: CreateOfficeSchedulePayload
): Promise<{ message: string; id: number }> => {
  const response = await interstellarApi.put<{ message: string; id: number }>(
    `/incoming-call-config/schedule/${scheduleId}`,
    payload
  );
  return response.data;
};

/**
 * Elimina un horario: `DELETE /incoming-call-config/schedule/{scheduleId}`
 */
export const deleteOfficeSchedule = async (scheduleId: number): Promise<void> => {
  await interstellarApi.delete(`/incoming-call-config/schedule/${scheduleId}`);
};
